import { TableHeaderColumnType } from '../../../../components/Table/TableHeader.component';

export const TABLE_HEADER_COLUMNS: TableHeaderColumnType[] = [
  {
    title: 'Title',
    dataProperty: 'name',
    sortable: true,
  },
  {
    title: 'Date testing',
    dataProperty: 'testing_at',
    sortable: true,
    sort: 'asc',
  },
  {
    title: 'Date start',
    dataProperty: 'start_at',
    sortable: true,
  },
  {
    title: 'Date end',
    dataProperty: 'end_at',
    sortable: true,
  },
  {
    title: 'Number of people',
    dataProperty: 'people_count',
    sortable: true,
  },
  {
    title: 'Status',
    dataProperty: 'status',
    sortable: false,
  },
  {
    title: 'Mentors',
    dataProperty: 'mentors',
    sortable: false,
  },
];
